<template>
  <div>
    <SectionTitle :content="model.name" :has-line="true" />
    <Question
      v-for="item in model.questions"
      :key="item.id"
      :section="model"
      :model="item"
      :readonly="readonly"
      @selected="onClickChild"
    />
  </div>
</template>
<script>
import Question from './Question';
import { SectionTitle } from '@/components/pei/shared';
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resources: [],
      isValid: false,
      message: '',
    };
  },
  components: {
    Question,
    SectionTitle,
  },
  methods: {
    validate() {
      this.isValid =
        this.model.questions
          .filter((x) => x.id === 5 || x.id === 6 || x.id === 13)
          .findIndex((x) => !x.selected) === -1;
      let question7 = this.model.questions.find((x) => x.id === 8);
      if (question7 !== undefined) {
        if (question7.selected === 1) {
          let question7a = this.model.questions.find((x) => x.id === 10);
          let question7b = this.model.questions.find((x) => x.id === 11);
          this.isValid = question7b.selected === 2 && question7a.selected === 1;
          this.message = this.isValid
            ? ''
            : question7b.selected
            ? 'Si la 7b es No, la 7a debe ser Sí.'
            : '';
          if (question7b.selected === 1) {
            let hasAgencies =
              question7b.agencies.filter(
                (agency) =>
                  agency.answers.filter((ans) => ans.selected).length === 0
              ).length === 0;
            this.isValid = question7b.selected === 1 && hasAgencies;
            this.message = this.isValid
              ? ''
              : 'Se requiere al menos una agencia.';
          } else if (question7b.selected === 2) {
            let answers = question7b.agencies[0].answers.filter(
              (q) => q.selected || q.selected > 0
            );
            answers.map((answer) => {
              answer.selected = null;
              return answer;
            });
          }
        } else if (question7.selected === 2) {
          let questions = this.model.questions.filter(
            (q) => q.numberLabel.indexOf('7(') >= 0
          );
          questions.map((question) => {
            question.selected = null;
            if (question.id === 11) {
              let answers = question.agencies[0].answers.filter(
                (q) => q.selected || q.selected > 0
              );
              answers.map((answer) => {
                answer.selected = null;
                return answer;
              });
            }
            return question;
          });
        }
      }

      this.$emit('changed', this.model, this.isValid, this.message);
    },
    onClickChild() {
      this.validate();
    },
  },
  mounted() {
    this.validate();
  },
};
</script>

<style scoped></style>
